import { render, staticRenderFns } from "./LoginHistory.vue?vue&type=template&id=8f18c4a0&scoped=true"
import script from "./LoginHistory.vue?vue&type=script&lang=ts"
export * from "./LoginHistory.vue?vue&type=script&lang=ts"
import style0 from "./LoginHistory.vue?vue&type=style&index=0&id=8f18c4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f18c4a0",
  null
  
)

export default component.exports